import React from 'react';
import { useSelector } from 'react-redux';
import _ from 'underscore';

import { Select, Form } from 'ui/components';
import { SkeletonsForm } from 'ui/components/skeleton';

const initialState = {
  service: null,
  name: null,
  pricing_schema: null,
  min_weight: null,
  dividers: null,
  options: null,
  isLoading: true,
};

let divide = [
  { value: '4000', label: '4000' },
  { value: '6000', label: '6000' },
  { value: '1000000', label: '1000000' },
];

const initialOptions = [
  { value: 'weight_point_based', label: 'Berbasis Berat per Titik' },
  { value: 'weight_based', label: 'Berbasis Berat' },
  { value: 'trip_based', label: 'Berbasis Perjalanan' },
  { value: 'colly_based', label: 'Berbasis Koli' },
  { value: 'dedicated_monthly', label: 'Berbasis Dedicate Perbulan' },
  { value: 'dedicated_daily', label: 'Berbasis Dedicate Perhari' },
];

const FormBulkUpdate = ({ data, onSubmit, onClose }) => {
  const StateForm = useSelector((state) => state.Form);

  const dummy = Array.from({ length: 2 }, (v, i) => i);

  const [
    { dividers, name, service, pricing_schema, min_weight, isLoading },
    setState,
  ] = React.useState(initialState);

  const $handleChangeDivider = (d) => {
    if (parseFloat(d?.value) > 0) {
      setState((prevState) => ({
        ...prevState,
        dividers: d,
      }));
    }
  };

  const $onSave = () => {
    const payload = {
      name,
      service,
      pricing_schema: pricing_schema?.value,
      min_weight: min_weight ? parseFloat(min_weight) : null,
      dividers: dividers ? parseFloat(dividers?.value) : null,
    };

    onSubmit(payload);
  };

  React.useEffect(() => {
    setTimeout(() => {
      setState((prevState) => ({
        ...prevState,
        isLoading: false,
      }));
    }, 2000);
  }, [isLoading]);

  React.useEffect(() => {
    const opt = _.filter(initialOptions, function (item) {
      if (service?.id === '62ac31041f1f25ecdc944b6a') {
        return (
          item?.value === 'dedicated_monthly' ||
          item?.value === 'dedicated_daily'
        );
      } else {
        return (
          item?.value !== 'dedicated_monthly' &&
          item?.value !== 'dedicated_daily'
        );
      }
    });

    setState((prevState) => ({ ...prevState, options: opt }));
  }, [service]);

  React.useEffect(() => {
    if (!data) return;
    setState((prevState) => ({
      ...prevState,
      isLoading: true,
    }));

    divide = [
      { value: '4000', label: '4000' },
      { value: '6000', label: '6000' },
      { value: '1000000', label: '1000000' },
    ];

    const ps =
      data?.pricing_schema === 'weight_point_based'
        ? initialOptions[0]
        : data?.pricing_schema === 'weight_based'
        ? initialOptions[1]
        : data?.pricing_schema === 'trip_based'
        ? initialOptions[2]
        : data?.pricing_schema === 'colly_based'
        ? initialOptions[3]
        : data.pricing_schema === 'dedicated_monthly'
        ? initialOptions[4]
        : data.pricing_schema === 'dedicated_daily'
        ? initialOptions[5]
        : null;

    const dv =
      data?.dividers === 4000
        ? divide[0]
        : data?.dividers === 6000
        ? divide[1]
        : data?.dividers === 1000000
        ? divide[2]
        : divide?.push({
            value: data?.dividers,
            label: data?.dividers,
          })
        ? divide[3]
        : null;

    setState((prevState) => ({
      ...prevState,
      service: data?.service,
      pricing_schema: ps,
      dividers: dv,
      name: data?.name,
      min_weight: data?.min_weight,
    }));
  }, [data]);

  if (isLoading) {
    return (
      <div className="px-3 py-4 bg-white my-3 border rounded-2">
        <div className="row m-0">
          {dummy?.map((d, i) => (
            <div className="col-md-6 col-12" key={i}>
              <SkeletonsForm count={2} />
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="px-3 py-4 bg-white my-3 border rounded-2">
      <div className="row">
        <div className="col-12">
          <div className="hr-text hr-text-left text-primary mb-3 ">
            Perbaharui
          </div>
        </div>
        <div className="col-md-6">
          <div className="mb-3">
            <Select.Remote
              required
              isSearch={false}
              label="Pilih Jenis Layanan"
              placeholder=""
              url="/tms/service"
              value={service}
              params={{
                service_id: service?.id,
              }}
              initialValue={service?.id || data?.service?.id}
              row={(d) => {
                return {
                  value: d.id,
                  label: d.name,
                };
              }}
              onSelected={(c) => {
                setState((prevState) => ({
                  ...prevState,
                  service: c,
                  dividers: null,
                }));
              }}
              errors={StateForm?.errors?.service_id}
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="mb-3">
            <Form.Input
              value={name || ''}
              horizontal
              required
              label="Nama Layanan"
              onChange={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  name: e.target.value,
                }))
              }
              type="text"
              error={StateForm?.errors?.name}
            />
          </div>
        </div>
        {service?.id === '61bb02262a457fc68763b774' && (
          <div className="col-md-6">
            <div>
              <label className="form-label">Pilih Pembagi Volumetrik</label>
              <Select.Createable
                isClearable
                classNamePrefix={
                  StateForm?.errors?.dividers ? 'is-invalid' : 'select'
                }
                placeholder=""
                value={dividers}
                options={divide}
                onChange={$handleChangeDivider}
                error={StateForm?.errors?.dividers}
              />
              <small className="form-hint pt-1">
                Silakan ketik pembagi volumetrik untuk buat baru
              </small>

              {StateForm?.errors?.dividers ? (
                <div className="invalid-feedback" style={{ display: 'block' }}>
                  {StateForm?.errors?.dividers}
                </div>
              ) : null}
            </div>
          </div>
        )}
      </div>

      <div className="d-flex justify-content-end align-items-center gap-3 border-top mt-4 pt-3 mb-0">
        <div
          className="btn btn-primary btn-sm rounded-2 px-5 "
          onClick={$onSave}
        >
          Simpan Perubahan
        </div>
        <div className="btn btn-danger btn-sm rounded-2 px-5" onClick={onClose}>
          Batal
        </div>
      </div>
    </div>
  );
};

export default FormBulkUpdate;
